module.exports = __webpack_public_path__ + "static/img/mouse.f170bef3.webp";